import { render, staticRenderFns } from "./DislikeBtn.vue?vue&type=template&id=6c0bd8c5&"
import script from "./DislikeBtn.vue?vue&type=script&lang=js&"
export * from "./DislikeBtn.vue?vue&type=script&lang=js&"
import style0 from "./DislikeBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports